var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-title',[_vm._v(" My Payments "),_c('v-spacer')],1),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.payments,"search":_vm.search,"loading":_vm.loading,"loading-text":"Loading... Please wait"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }